<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="Nation">
          <img class="location" :src="LocationIcon" v-if="LocationIcon!=null">
          <!-- <i class="location" :style="LocationIcon!=null?'background-image:url('+LocationIcon+')':''"  v-if="LocationIcon!=null"></i> -->
          <el-select class="login_ipt location_ipt" :class="LocationIcon!=null?'info_ipt':''" v-model="ruleForm.memberSource" :placeholder="$t('SelectCountryRegion')" @change='changeLocation'>
            <el-option v-for="(item,index) in nationList" :key="index" :label="$i18n.locale!='zh'?item.EnName:item.ChName" :value="item.Code">
              <div class="locationOption">
                <img :src="item.IconUrl">
                <span>{{$i18n.locale!='zh'?item.EnName:item.ChName}}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="login_form_item" prop="mobile">
          <span class="locationcode">{{ruleForm.nationCode}}</span>
          <el-input class="login_ipt" :class="ruleForm.nationCode!=''?'info_ipt':''" v-model="ruleForm.mobile" :placeholder="$t('verify.PhoneNumber1')" @input="setInput()">
          </el-input>
        </el-form-item>
        <div class="codeText">
          <el-form-item class="login_form_item" prop="code">
            <el-input class="login_ipt codeIpt" v-model="ruleForm.code" :placeholder="$t('verify.VerificationCode')" @input="setInput()"></el-input>
          </el-form-item>
          <el-button class="login_btn codeBtn" :disabled='isCode' type="primary" @click="getCode('ruleForm')">{{codeText}}</el-button>
        </div>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" minlength='6' maxlength='20' :placeholder="$t('verify.Password')" @input="setInput('password')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
          <span class="noError" :class="`lang-${$i18n.locale}`">{{$t('verify.WordCount')}}</span>
        </el-form-item>
        <el-form-item class="login_form_item" prop="nickName">
          <el-input class="login_ipt" v-model="ruleForm.nickName" :placeholder="$t('verify.nickname')" minlength='1' maxlength='20' @input="setInput('nickName')"></el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">{{$t('SignUp')}}</el-button>
        <div class="returnLogin">{{$t('verify.AlreadyAccount')}}<span @click="godialog('login','register')">{{$t('SignIn')}}</span></div>
        <div>
          <el-checkbox v-model='checked' :label="$t('RememberMe')" name="type">
            <i18n path="agreeTo" tag="div" class="userText">
              <router-link class="text_blue" :to="{path:'/useragreement'}" target="_blank">{{$t('UserAgreement')}}</router-link>
              <router-link class="text_blue" :to="{path:'/privacyagreement'}" target="_blank">{{$t('PrivacyPolicy')}}</router-link>
            </i18n>
          </el-checkbox>
        </div>
        <!-- <div class="userText U25">登录或注册即代表同意 <router-link :to="{path:'/'}">用户协议</router-link> 和 <router-link :to="{path:'/'}">隐私政策</router-link>
        </div> -->
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { isEmoji, setInfo, login } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    return {
      loading: false,
      times: 60,
      flagType: 'password',
      flag: false,
      checked: false,
      codeText: this.$t('SendCode'),
      isCode: true,
      disabled: true,
      dialogClass: 'user',
      nationList: '',
      nation: '86',
      LocationIcon: null,
      ruleForm: {
        mobile: '',
        password: '',
        nickName: '',
        code: '',
        memberSource:'CN',
        nation: this.$i18n.locale!='zh'?'China':'中国',
        nationCode:'+86'
      },
      rules: {
        code: [
          { required: true, message: this.$t('verify.VerificationCode'), trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: this.$t('verify.PhoneNumber1'), trigger: 'blur' },
          { pattern: /^\+?[1-9]\d{1,14}$/, message: this.$t('verify.ValidPhoneNumber'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('verify.Password'), trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('verify.WordCount'), trigger: 'blur' },
        ],
        nickName: [
          { required: true, message: this.$t('verify.nickname'), trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    that.getNationList()
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm');
        }
      }
    })
    //console.log(this.$interface.SignIn)
  },
  methods: {
    changeLocation(e) {
      let that = this
      that.nationList.map(res => {
        if (res.Code == e) {
          that.ruleForm.nationCode=res.NationCode
          that.ruleForm.nation=(that.$i18n.locale!='zh'?res.EnName:res.ChName)
          that.LocationIcon = res.IconUrl
        }
      })
    },
    getNationList() {
      let that = this;
      let data = { PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetNationList, data).then(res => {
        if (res.Result != 0) {
          that.nationList = countries(res.Data) 
          that.changeLocation('CN');
        }
      })
    },
    // 点击快捷跳转 登陆
    godialog(toval, val) {
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    //获取验证码
    getCode(formName) {
      let that = this;
      that.isCode = true;
      this.$refs[formName].validateField('mobile', (val) => {
        if (val == "") {
          that.isCode = true;
          if (that.times == 60) {
            that.codeText = that.times + 's';
          }
          that.timer = setInterval(() => {
            that.times--;
            that.codeText = that.times + 's';
            if (that.times === 0) {
              clearInterval(that.timer)
              that.times = 60;
              that.codeText = this.$t('SendCode');
              that.isCode = false;
            }
          }, 1000)
          var Nation = that.ruleForm.nationCode
          if (Nation.indexOf('+') > -1) {
            Nation = Nation.slice(1)
          }
          let data = {
            NationCode: Nation,
            mobile: that.ruleForm.mobile,
            type: 1
          }
          this.$post(this.$interface.SendMobileCode, data).then(res => {
            if (res.Result != 0) {} else {
              that.times = 60;
              that.codeText = this.$t('SendCode');
              that.isCode = false;
              clearInterval(that.timer);
              this.$message.error(res.Msg);
            }
          }).catch({})
        } else {
          that.isCode = true
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('closeDialog', 'register', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
    },
    // 判断input是否有值
    setInput(val) {
      this.$refs['ruleForm'].validateField('mobile', (val) => {
        if (val == "") {
          this.isCode = false
        } else {
          this.isCode = true
        }
      })
      // if (this.ruleForm.mobile != '') {
      //   this.isCode = false
      // } else {
      //   this.isCode = true
      // }
      if (val == 'nickName' || val == 'password') {
        this.ruleForm[val] = isEmoji(this.ruleForm[val], 1)
      }
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '' && this.ruleForm.nickName != '' && this.ruleForm.code != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 注册
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true;
          that.disabled = true;

          if (that.checked) {
            let data = that.ruleForm
            
            var Nation = that.ruleForm.nationCode
            if (Nation.indexOf('+') > -1) {
              Nation = Nation.slice(1)
              data.nationCode=Nation
            }
            that.$post(that.$interface.Register, data).then(res => {
              if (res.Result != 0) {
                login(res.Data)
                that.closeDialog()
                //this.closeDialog();
              } else {
                that.$message.error(res.Msg);
              }
              that.loading = false;
            }).catch({})
          } else {
            that.$message.error(that.$t('verify.AgreeToTerms'));
            that.loading = false;
            that.disabled = false
          }
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

.location_ipt {
  width: 100%;
}

/deep/.info_ipt .el-input .el-input__inner,
/deep/.login_ipt.info_ipt .el-input__inner {
  padding-left: 40px;
}

.locationOption {
  display: flex;
  align-items: center;
  width: 258px;
}

.locationOption img {
  width: 24px;
  height: 16px;
  border: 0.2px solid #F0F0F0;
  border-radius: 2px;
  margin-right: 4px;
}

.locationcode {
  position: absolute;
  z-index: 9;
  color: var(--text-secondary);
  top: 2px;
  left: 10px;
}

.location {
  width: 24px;
  height: 16px;
  border: 0.2px solid #F0F0F0;
  border-radius: 2px;
  position: absolute;
  z-index: 9;
  top: 13px;
  left: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/register.vue